const formatter = new Intl.NumberFormat('de', { maximumFractionDigits: 0 })

export const format = (value: string | number) => {
  const stringValue = String(value)

  if (stringValue.length === 0) {
    return stringValue
  }

  return formatter.format(+stringValue.replace(/\D/g, ''))
}

export const deFormat = (value: string) =>
  parseInt(value.replace(/\./g, ''), 10)
